export type PanelLocale = 'en' | 'fa'

const LANGUAGE_SEGMENT = /^\/(en|fa)(?=\/|$)/i

/** The route is authoritative; bare Panel routes retain their English default. */
export function resolvePanelLocale(pathname: string): PanelLocale {
  return pathname.match(LANGUAGE_SEGMENT)?.[1].toLowerCase() === 'fa'
    ? 'fa'
    : 'en'
}

/** Change only the leading language segment, never an ID, query or fragment. */
export function localizedPathname(
  pathname: string,
  locale: PanelLocale
): string {
  if (LANGUAGE_SEGMENT.test(pathname)) {
    return pathname.replace(LANGUAGE_SEGMENT, `/${locale}`)
  }
  return locale === 'en' ? pathname : `/fa${pathname}`
}
